import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
// import details from '@/components/Details'
import personalc from '@/component/PersonalC'
import pushorder from '@/component/pushorder'
import pushorderlog from '@/component/pushorderlog'
import fansGroup from '@/component/fansGroup'
import yieldmain from '@/component/yieldmain'
import xiugaipersonalc from '@/component/XiugaiPersonalC'
import bankc from '@/component/BankC'
import xiugaipassword from '@/component/XiugaiPassword'
import bangdingidentity from '@/component/BangdingIdentity'
import bangdingshoujihao from '@/component/BangdingShoujihao'
import bangdingxinshoujihao from '@/component/BangdingXinshoujihao'
import zhiboshuju from '@/component/Zhiboshuju'
import shezhiguanliyuan from '@/component/Shezhiguanliyuan'
import guanlijinyan from '@/component/Guanlijinyan'
import yonghupaihangbang from '@/component/Yonghupaihangbang'
import wodeshouyi from '@/component/Wodeshouyi'
import wodeguanzhu from '@/component/Wodeguanzhu'
import lishiguankan from '@/component/Lishiguankan'
import yonghuyemian from '@/component/Yonghuyemian'
import gerenyemian from '@/component/Gerenyemian'
import shangcheng from '@/component/Shangcheng'
import wodefensi from '@/component/Wodefensi'
import tianjiazhiboyuan from '@/component/Tianjiazhiboyuan'
import aaaaaa from '@/components/aaaaaa'
import download from '@/component/Download'
import wodezichan from '@/component/Wodezichan'
import search from '@/component/search'
import binduser from '../component/binduser.vue'

// 创作中心
import centervideo from '@/pages/mine/video'

import informationlist from '@/pages/template/informationlist'
import infomationdetails from '@/pages/template/infomationdetails'

import publicDetails from '@/pages/template/publicDetails'


// 比分-走势-详情

import scopeDetails from '@/pages/template/scopeDetails'
// 招聘主播界面

import bannerDownload from '@/pages/template/bannerDownload'

// 下载开播助手页面
import helpDown from '@/pages/template/helpDown'

// web ios 下载
import pageFull from '@/pages/pageFull'
// 开播指南
import kaiboHelp from '@/pages/template/kaiboHelp'
// 备案
import website from '@/pages/template/website'

// 关于我们
import about from '@/pages/template/about'
import innerWeb from '@/pages/template/innerWeb'

// 进度条
import NProgress from 'nprogress'; // progress bar
import 'nprogress/nprogress.css'; // progress bar style

// 直播分类界面
import pageLive from '@/pages/pageLive'
// 直播间界面
import roomLive from '@/pages/roomLive'
// 即时比分
import pageScore from '@/pages/pageScore'
// 认证主播
import anchor from '@/pages/template/anchor'

import pageAnalyse from '@/pages/analyse'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    //搜索首页
    {
      path: '/search',
      name: 'search',
      component: search
    },
    // 主播认证
    {
      path: '/anchor',
      name: 'anchor',
      component: anchor
    },
    // 首页
    {
      path: '/',
      name: 'HelloWorld',
      component: HelloWorld
    },
    // 个人中心
    {
      path: '/personalc',
      name: 'personalc',
      component: personalc
    },
    // 推单管理
    {
      path: '/pushorder',
      name: 'pushorder',
      component: pushorder
    },
    // 购买推单记录
    {
      path: '/pushorderlog',
      name: 'pushorderlog',
      component: pushorderlog
    },
    // 粉丝群
    {
      path: '/fansGroup',
      name: 'fansGroup',
      component: fansGroup
    },

    {
      path:'/yieldmain',
      name: 'yieldmain',
      component: yieldmain
    },
    // 修改个人信息
    {
      path: '/xiugaipersonalc',
      name: 'xiugaipersonalc',
      component: xiugaipersonalc
    },
    // 绑定银行卡
    {
      path: '/bankc',
      name: 'bankc',
      component: bankc
    },
    // 修改密码
    {
      path: '/xiugaipassword',
      name: 'xiugaipassword',
      component: xiugaipassword
    },
    // 绑定身份证
    {
      path: '/bangdingidentity',
      name: 'bangdingidentity',
      component: bangdingidentity
    },
    // 绑定手机号
    {
      path: '/bangdingshoujihao',
      name: 'bangdingshoujihao',
      component: bangdingshoujihao
    },
    // 绑定新手机号
    {
      path: '/bangdingxinshoujihao',
      name: 'bangdingxinshoujihao',
      component: bangdingxinshoujihao
    },
    // 直播数据
    {
      path: '/zhiboshuju',
      name: 'zhiboshuju',
      component: zhiboshuju
    },
    // 设置管理员
    {
      path: '/shezhiguanliyuan',
      name: 'shezhiguanliyuan',
      component: shezhiguanliyuan
    },
    // 管理禁言
    {
      path: '/guanlijinyan',
      name: 'guanlijinyan',
      component: guanlijinyan
    },
    // 添加直播源
    {
      path: '/tianjiazhiboyuan',
      name: 'tianjiazhiboyuan',
      component: tianjiazhiboyuan,
    },
    // 用户排行榜
    {
      path: '/yonghupaihangbang',
      name: 'yonghupaihangbang',
      component: yonghupaihangbang
    },
    // 我的收益
    {
      path: '/wodeshouyi',
      name: 'wodeshouyi',
      component: wodeshouyi
    },
    // 我的关注
    {
      path: '/wodeguanzhu',
      name: 'wodeguanzhu',
      component: wodeguanzhu
    },
    // 我的粉丝
    {
      path: '/wodefensi',
      name: 'wodefensi',
      component: wodefensi
    },
    // 历史观看
    {
      path: '/lishiguankan',
      name: 'lishiguankan',
      component: lishiguankan
    },
    // 下载页面
    {
      path: '/wodezichan',
      name: 'wodezichan',
      component: wodezichan
    },
    // 用户页面
    {
      path: '/yonghuyemian',
      name: 'yonghuyemian',
      component: yonghuyemian
    },
    // 个人页面
    {
      path: '/gerenyemian',
      name: 'gerenyemian',
      component: gerenyemian
    },
    // 商城
    {
      path: '/shangcheng',
      name: 'shangcheng',
      component: shangcheng
    },
    // 创作中心

    {
      path: '/centervideo',
      name: 'centervideo',
      component: centervideo
    },
    // 资讯列表
    {
      path: '/informationlist',
      name: 'informationlist',
      component: informationlist
    },
    // 咨询详情
    {
      path: '/news',
      name: 'news',
      component: infomationdetails
    },
    // 公告详情
    {

      path: '/public',
      name: 'public',
      component: publicDetails
    },
    // 招聘主播
    {
      path: '/bannerDownload',
      name: 'bannerDownload',
      component: bannerDownload
    },
    // 比分详情
    {
      path: '/scopeDetails',
      name: 'scopeDetails',
      component: scopeDetails
    },
    // 下载指引 helpDown
    {
      path: '/helpDown',
      name: 'helpDown',
      component: helpDown
    },
    // 开播指南 kaiboHelp
    {
      path: '/kaiboHelp',
      name: 'kaiboHelp',
      component: kaiboHelp
    },
    {
      path: '/website',
      name: 'website',
      component: website
    },
    // 关于我们
    {
      path: '/about',
      name: 'about',
      component: about
    },
    // 内页
    {
      path: '/innerWeb',
      name: 'innerWeb',
      component: innerWeb
    },

    // 下载页面
    {
      path: '/download',
      name: 'download',
      component: download
    },
    // 下载页面
    {
      path: '/pageFull',
      name: 'pageFull',
      component: pageFull
    },
    // 直播分类界面
    {
      path: '/pageLive',
      name: 'pageLive',
      component: pageLive
    },
    // 直播房间
    // 直播分类界面
    {
      path: '/roominfo',
      name: 'roominfo',
      component: roomLive
    },
    // 即时比分
    {
      path: '/pageScore',
      name: 'pageScore',
      component: pageScore
    },
    // 分析数据
    {
      path: '/pageAnalyse',
      name: 'pageAnalyse',
      component: pageAnalyse
    },
    //binduser qq登录绑定手机号
    {
      path: '/binduser',
      name: 'binduser',
      component: binduser
    }
  ]
})

// 全局前置守卫  当 路由发生变化时 这个方法里的回调函数就会执行
router.beforeEach(function (to, from, next) {
  NProgress.start() // 开启进度条
  // 权限拦截 认为有token 让过去 没token不让过
  console.log('%c [ to ]: ', 'color: #bf2c9f; background: pink; font-size: 13px;', to)
  // if (to.path.startsWith('/home')) {
  //   确定要去检查的范围
  let token = window.localStorage.getItem('token')
  if (token) {
    next() // 放过
  } else {
    // 清除用户信息--跳转登录页
    window.localStorage.removeItem('token')
    next() // 跳转到登录页
  }
  // }
  //  else {
  //   next() // 直接放过
  // }
})
router.afterEach(() => {
  // setTimeout(() => progresss.done(), 1000)
  NProgress.done()
  // 关闭进度条
})

export default router;


const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}



// WEBPACK FOOTER //
// ./src/router/index.js